import { SET_VIEW_ID } from '../helpers/constants/actionsConstants';

import type { SetViewIdAction } from './types';

export const setViewId = (viewId: string): SetViewIdAction => ({
  type: SET_VIEW_ID,
  payload: viewId,
});
